import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Button, Space, Table} from "antd";
import {Link, useParams} from "react-router-dom";
import {setKey} from "../util/util";
import Icon from "./Icon";
import MatchTable from "./MatchTable";

export default (prop) => {

    const {t} = useTranslation()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [heroId, setHeroId] = useState(null)


    const columns = [
        {
            key: 'heroId',
            dataIndex: 'heroId',
            title: t('heroListTitle.hero'),
            render: (heroId) => <a style={{fontSize: '20px'}} onClick={() => setHeroId(heroId)}><Space><Icon type={'hero'} name={heroId} size={28} /><span>{t(`heroName.${heroId}`)}</span></Space></a>,
            align: 'right',
            sorter: (a, b) => a.heroId - b.heroId,
        },
        {
            key: 'total',
            dataIndex: 'total',
            title: t('heroListTitle.total'),
            align: 'center',
            sorter: (a, b) => a.total - b.total,
        },
        {
            key: 'winPercentage',
            dataIndex: 'winPercentage',
            title: t('heroListTitle.winPercentage'),
            align: 'center',
            render: (percentage) => `${percentage}%`,
            sorter: (a, b) => a.winPercentage - b.winPercentage,
        },
        {
            key: 'mmr',
            dataIndex: 'mmr',
            title: t('mmr'),
            align: 'center',
            sorter: (a, b) => a.mmr - b.mmr,
        },
    ]

    useEffect(() => {
        setLoading(true)
        axios.get(`hero/list2/${prop.playerHandle}`).then(data => {
            setKey(data, 'heroId')
            setData(data)
            setLoading(false)
        })
    }, [prop.playerHandle])

    return <Space direction={'vertical'} size={30}>
        {
            !heroId && <Table size={'middle'} style={{  width: '440px', }} columns={columns} pagination={false} dataSource={data} loading={loading}/>
            ||
            <Space direction={'vertical'}>
                <Button onClick={() => setHeroId(null)}>{t('back')}</Button>
                <MatchTable heroId={heroId} playerHandle={prop.playerHandle} style={{  width: '900px', }} columns={['mode', 'duration', 'hero', 'kda', 'result', "score", 'endTime']} update={(pageInfo, setData) => {
                    axios.get(`game/list`,{
                        params: {
                            current: pageInfo.current,
                            pageSize: 10,
                            heroId,
                            playerHandle: prop.playerHandle,
                        }
                    }).then(data => {
                        setKey(data.records, 'id')
                        pageInfo.total = data.total
                        pageInfo.pageSize = 10
                        setData(data.records)
                    })
                }}/>
            </Space>
        }


    </Space>
}
